export const getPartnerLink = (partnerName) => {
  if (partnerName === 'TurboTenant') {
    return 'https://support.reihub.net/category/67-turbotenant-integration';
  }
  if (partnerName === 'RentRedi') {
    return 'https://support.reihub.net/category/63-rentredi-integration';
  }
  return 'https://support.reihub.net/';
};
